import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store/store";
import PatientSelect from "@components/PatientSelect/PatientSelect";
import { selectPatientId } from "@store/homeSlice";
import { useGetAccountsQuery } from "@store/accountApi";
import { AccountType } from "@models/account";
import { useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const HomePatientSelect: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patients = useSelector((state: RootState) => state.home.patients);
  const selectedPatientId = useSelector(
    (state: RootState) => state.home.selectedPatientId,
  );
  const { data: accounts } = useGetAccountsQuery();
  const account = accounts?.data?.[0];
  const canManagePatients = account?.type === AccountType.Organization;

  const onSelectPatient = (patientId: string | null) => {
    dispatch(selectPatientId(patientId));
  };

  const onManagePatients = () => {
    navigate("/patients/manage");
  };

  return (
    <Container>
      <PatientSelect
        patients={patients}
        selectedPatientId={selectedPatientId}
        onChange={onSelectPatient}
      />
      {canManagePatients && (
        <IconButton
          aria-label={t("patientSelect.managePatients")}
          title={t("patientSelect.managePatients")}
          size="small"
          onClick={onManagePatients}
          sx={{
            backgroundColor: "primary.main",
            color: "primary.contrastText",
            width: 28,
            height: 28,
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          }}
        >
          <ManageAccountsOutlinedIcon fontSize="small" />
        </IconButton>
      )}
    </Container>
  );
};

export default HomePatientSelect;
